import React, {Component} from 'react';
import yesIcon from './YesOutline.svg';
import noIcon from './NoOutline.svg';
import yesFill from './YesFill.svg'
import noFill from './NoFill.svg'
import styles from './Feedback.module.css';
import axios from 'axios';
import ReactGA from 'react-ga'

class Feedback extends Component{
    constructor(props){
        super(props);
        this.state={
            feedback:props.feedback
        }
    }

    gaEvent(action){
        ReactGA.event({
            category: 'Social',
            action: action
          });
    }

    set_feedback(feedback){
        if(feedback && feedback!==this.state.feedback){
            this.sendFeedback(feedback);
        }
        this.setState({feedback},this.gaEvent(feedback));
	}
	
    sendFeedback(feedback){
		const params={
			contentid:this.props.content_id,
			feedback
        };
		axios.get(window.global.content_hub.API+'/api/feedback',{params,withCredentials:true})
			.then((res)=>{
				this.setState({feedback});
			})
			.catch(err=>console.log(err));
	}
    render(){
		return (<div className={styles.feedback_container}>
			{this.state.feedback==='like' || this.state.feedback==='dislike'
				?<div className={styles.feedback_label}>Change rating?</div>
				:<div className={styles.feedback_label}>Did you find this article helpful?</div>}
			
			<img alt="" className={styles.feedback_icon} src={(this.state.feedback==='like'?yesFill:yesIcon)} onClick={()=>this.set_feedback('like')}></img>
			<img alt="" className={styles.feedback_icon} src={(this.state.feedback==='dislike'?noFill:noIcon)} onClick={()=>this.set_feedback('dislike')}></img>
		</div>)
    }
}

export default Feedback;